/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { authState } from "./auth.state"
import { authorizationRequest } from "./auth.api"

const TOKEN_KEY = "sdev_token"

export function getToken() {
    return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken() {
    localStorage.removeItem(TOKEN_KEY)
}

function decodeToken(token) {

    try {

        const payload = token.split(".")[1]

        const decoded = atob(payload.replace(/-/g, "+").replace(/_/g, "/"))

        return JSON.parse(decoded)

    } catch {

        return null

    }

}
export function getUser() {
    return authState.user
}

export function getIdentityId() {
    return authState.user?.sub ?? null
}

export function getIdentityKey() {
    return authState.user?.key ?? null
}

export function getAuthHeader() {
    const token = getToken()
    if (!token) return {}
    return {
        Authorization: `Bearer ${token}`
    }
}
export function isTokenValid(token = getToken()) {
    if (!token) return false
    const payload = decodeToken(token)
    if (!payload?.exp) return false
    return Date.now() < payload.exp * 1000
}
export async function initializeAuth() {
    const token = getToken()

    if (isTokenValid(token)) {
        authState.isAuthenticated = true
        authState.user = decodeToken(token)
    } else {
        clearToken()
        authState.isAuthenticated = false
        authState.user = null
    }

    authState.authReady = true
}
export async function login(identity_key, password, options = {}) {

    const res = await authorizationRequest(identity_key, password)

    const token = res.data?.token ?? res.token

    if (!token) {
        throw new Error("Login succeeded but token missing")
    }

    setToken(token)

    authState.user = decodeToken(token)

    if (!options.deferActivation) {
        authState.isAuthenticated = true
    }

    return authState.user
}

export function activateAuthenticatedSession() {
    if (!isTokenValid()) {
        throw new Error("Authenticated session is no longer valid")
    }

    authState.isAuthenticated = true
}
export function logout() {
    clearToken()
    authState.isAuthenticated = false
    authState.user = null
}
